import { useEffect, useRef } from 'react';
import type { PlayerHandle } from '../../types/app';

interface BitmovinPlayerProps {
  onReady: () => void;
  src: string;
}

const getSource = (src: string): Record<string, string> => {
  if (/\.mpd(?:$|\?)/i.test(src)) return { dash: src };
  if (/\.m3u8(?:$|\?)/i.test(src)) return { hls: src };
  return { progressive: src };
};

export const BitmovinPlayer = ({ onReady, src }: BitmovinPlayerProps) => {
  const rootRef = useRef<HTMLDivElement>(null);
  const playerRef = useRef<PlayerHandle | null>(null);

  useEffect(() => {
    if (!rootRef.current || !window.bitmovin) return;

    const player = new window.bitmovin.player.Player(rootRef.current, {
      key: 'fafdd7cb-81a4-44d2-af46-498602d077bc',
      playback: {
        autoplay: true,
        muted: true,
        preload: true,
      },
    });
    playerRef.current = player;

    player
      .load?.({ title: 'In The Game', ...getSource(src) })
      .then(onReady)
      .catch((error: unknown) =>
        console.error('Bitmovin failed to load', error),
      );

    return () => {
      player.dispose?.();
      playerRef.current = null;
    };
  }, [onReady, src]);

  return (
    <div
      ref={rootRef}
      id="itg-player"
      className="h-full w-full"
      data-player-root
    />
  );
};
